import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import { Fragment, useRef, useState } from 'react';
import { useLocationState } from '../context/location';
import { submitClientRequest } from '../helpers/clientRequest';
import Intro from '../components/Intro';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Splitter from '../components/Splitter';
import CareerVacancy from '../components/career/CareerVacancy';
import CareerPreferences from '../components/career/CareerPreferences';
import Input from '../components/Input';
import Textarea from '../components/Textarea';
import FormAgreement from '../components/FormAgreement';

const Modal = dynamic(() => import('../components/Modal'));

const CareerPage = () => {
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: '/career',
        whatComponent: 'CareerPage',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <Fragment>
      <Modal
        title="Оставить заявку"
        button={!isSubmited && 'Отправить'}
        buttonDisabled={!agreeWithPolicy}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
            </div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки!
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Хочу работать у вас, вы меня научите всему?»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <NextSeo
        title="Работа в Ростове-на-Дону в «ЛЕНДЛОРД»"
        description="Работа ЛЕНДЛОРД в Ростове-на-Дону, Азове, Новочеркасске и Батайске - вакансии в сфере недвижимости. Агентство недвижимости «ЛЕНДЛОРД» - поможет найти работу и вакансии в Ростове-на-Дону"
        openGraph={{
          url: 'https://landlord.ru',
          type: 'website',
          title: 'Работа в Ростове-на-Дону в «ЛЕНДЛОРД»',
          description:
            'Работа ЛЕНДЛОРД в Ростове-на-Дону, Азове, Новочеркасске и Батайске - вакансии в сфере недвижимости. Агентство недвижимости «ЛЕНДЛОРД» - поможет найти работу и вакансии в Ростове-на-Дону',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <Header />
      <main>
        <Intro
          title="Мир меняют команды"
          description="Постоянное развитие и обучение, достойная оплата, карьерный рост, корпоративная культура и многое другое"
          image="/images/stock-8.webp"
          button="Отправить заявку"
          phone="+7 800 222 81 08"
          phoneURI="tel:+79034014754"
          onClick={() => setIsModalVisible(true)}
        />
        <CareerPreferences />
        <CareerVacancy />
        <Splitter
          title="Присоединяйся к нашей команде!"
          subtitle="Укажите свой номер телефона и мы в скором времени свяжемся с Вами"
        />
      </main>
      <Footer seo="" />
    </Fragment>
  );
};

export default CareerPage;
